import { ExamDoneReason } from "@/components/pages/Exam/ExamDone/exam-done-reason.enum";
import { format } from "date-fns";

const REGISTER_ROUTE = (base: string, path: string) => {
  const routes = {
    root: () => base + "/" + path,
    checkInfo: () => routes.root(),
    acknowledgment: () => routes.root() + "/acknowledgment",
    certificate: () => routes.root() + "/certificate",
    pricing: () => routes.root() + "/pricing",
    payement: () => routes.root() + "/payement",
    registerStep: () => routes.root() + "/register-step",
  };

  return routes;
};

const ROUTE = {
  home: () => "/",
  connectionHome: () => "/home",
  seedData: () => "/seed-data",
  admin: {
    root: () => "/admin",
    login: () => ROUTE.admin.root() + "/login",
    dashboard: {
      root: () => ROUTE.admin.root() + "/dashboard",
      candidates: () => ROUTE.admin.dashboard.root() + "/candidates",
      candidate: {
        root: (id?: number) =>
          ROUTE.admin.dashboard.root() +
          (id ? `/candidate/${id}` : "/candidate"),
        onGoingSession: (id: number) =>
          ROUTE.admin.dashboard.candidate.root(id),
        results: (id: number) =>
          ROUTE.admin.dashboard.candidate.root(id) + "/results",
        documents: (id: number) =>
          ROUTE.admin.dashboard.candidate.root(id) + "/documents",
        personalInformation: (id: number) =>
          ROUTE.admin.dashboard.candidate.root(id) + "/personal-information",
        certificates: (id: number) =>
          ROUTE.admin.dashboard.candidate.root(id) + "/certificates",
        register: (candidateId: number) =>
          REGISTER_ROUTE(
            ROUTE.admin.dashboard.candidate.root(candidateId),
            "register"
          ),
      },
      sessions: {
        root: () => ROUTE.admin.dashboard.root() + "/sessions",
        creation: () => ROUTE.admin.dashboard.sessions.root() + "/creation",
      },
      foreignCertificates: () =>
        ROUTE.admin.dashboard.root() + "/foreign-certificates",
      sessionCreation: () => ROUTE.admin.dashboard.root() + "/session-creation",
      session: {
        root: (sessionId?: number) =>
          ROUTE.admin.dashboard.root() +
          (sessionId !== undefined ? `/session/${sessionId}` : "/session"),
        candidates: (sessionId: number) =>
          ROUTE.admin.dashboard.session.root(sessionId),
        information: (sessionId: number) =>
          ROUTE.admin.dashboard.session.root(sessionId) + "/information",
      },
      companies: () => ROUTE.admin.dashboard.root() + "/companies",
      company: (companyId: number) =>
        ROUTE.admin.dashboard.root() + `/company/${companyId}`,
      questions: () => ROUTE.admin.dashboard.root() + "/questions",
      question: (questionId: number) =>
        ROUTE.admin.dashboard.root() + `/question/${questionId}`,
      administration: {
        root: () => ROUTE.admin.dashboard.root() + "/administration",
        formationInstitutes: () =>
          ROUTE.admin.dashboard.administration.root() + "/formation-institutes",
        prices: () => ROUTE.admin.dashboard.administration.root() + "/prices",
        admissionNotes: () =>
          ROUTE.admin.dashboard.administration.root() + "/admission-notes",
        QCMParameters: () =>
          ROUTE.admin.dashboard.administration.root() + "/qcm-parameters",
        exports: () => ROUTE.admin.dashboard.administration.root() + "/exports",
        admins: () => ROUTE.admin.dashboard.administration.root() + "/admins",
        archivedExams: () =>
          ROUTE.admin.dashboard.administration.root() + "/archived-exams",
        archivedCandidates: () =>
          ROUTE.admin.dashboard.administration.root() + "/archived-candidates",
      },
      registrations: () => ROUTE.admin.dashboard.root() + "/registrations",
      payements: () => ROUTE.admin.dashboard.root() + "/payements",
      qcms: () => ROUTE.admin.dashboard.root() + "/qcms",
      qcm: (date: Date) =>
        `${ROUTE.admin.dashboard.root()}/qcm/${format(date, "yyyy-MM-dd")}`,
      live: {
        root: () => ROUTE.admin.dashboard.root() + "/live",
        sessions: () => ROUTE.admin.dashboard.live.root() + "/sessions",
        session: (examId: number) =>
          ROUTE.admin.dashboard.live.root() + `/session/${examId}`,
      },
    },
  },
  candidate: {
    root: () => "/candidate",
    accountCreation: () => ROUTE.candidate.root() + "/account-creation",
    dashboard: {
      root: () => ROUTE.candidate.root() + "/dashboard",
      profile: () => ROUTE.candidate.dashboard.root() + "/profile",
      cgu: () => ROUTE.candidate.dashboard.root() + "/cgu",
      cgv: () => ROUTE.candidate.dashboard.root() + "/cgv",
      exams: {
        root: () => ROUTE.candidate.dashboard.root() + "/exams",
        home: () => ROUTE.candidate.dashboard.exams.root() + "/home",
        payementSuccessful: () =>
          ROUTE.candidate.dashboard.exams.home() + "?payementSuccessful=true",
        payementCancelled: () =>
          ROUTE.candidate.dashboard.exams.home() + "?payementCancelled=true",
        register: () =>
          REGISTER_ROUTE(ROUTE.candidate.dashboard.exams.root(), "register"),
      },
    },
  },
  company: {
    root: () => "/company",
    dashboard: {
      root: () => ROUTE.company.root() + "/dashboard",
      information: () => ROUTE.company.dashboard.root() + "/information",
      delegations: () => ROUTE.company.dashboard.root() + "/delegations",
      candidates: () => ROUTE.company.dashboard.root() + "/candidates",
    },
    accountCreation: () => ROUTE.company.root() + "/account-creation",
  },
  exam: {
    root: () => "/exam",
    questions: () => ROUTE.exam.root(),
    login: () => ROUTE.exam.root() + "/login",
    done: (reason: ExamDoneReason) => ROUTE.exam.root() + "/done/" + reason,
  },
  forgotten: {
    root: () => "/forgotten",
    password: {
      root: () => ROUTE.forgotten.root() + "/password",
      ask: () => ROUTE.forgotten.password.root() + "/ask",
      reset: () => ROUTE.forgotten.password.root() + "/reset",
    },
    email: {
      root: () => ROUTE.forgotten.root() + "/email",
      ask: () => ROUTE.forgotten.email.root() + "/ask",
    },
  },
  payement: {
    root: () => "/payement",
    success: () => ROUTE.payement.root() + "/success",
    cancel: () => ROUTE.payement.root() + "/cancel",
  },
};

export { ROUTE };
